import { Button, Col, Empty, message as messager, Modal, Row, Table } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { ColumnsType } from "antd/lib/table";

import modStyl from './index.module.scss'
import CreateModal from "./components/create-modal";
import { delAdmEmail, getAdmEmail } from "../../../services/plat/plat";

export type DataType = {
  code: string
  config: string
  icon: string
  method: string
  name: string
  appCode: string
  parentCode: string
  type: string
  url: string
}

type Props = {

}
const EmailManagement: React.FC<Props> = ()=> {

  const [loading, setLoading] = useState(false)

  const [dataSource, setDataSource] = useState<any[]>([])

  const [visible, setVisible] = useState(false)

  //#region 表格列
  const columns: ColumnsType<DataType> = [
    {
      title: '邮箱地址',
      dataIndex: 'email',
    },
    {
      width: 150,
      title: '添加时间',
      dataIndex: 'createTime',
    },
    {
      width: 150,
      title: '操作',
      align: 'center',
      dataIndex: 'email',
      render: (value: any, record: DataType)=> (
        <Button onClick={()=> handleRemove(value)} danger size="small">删除</Button>
      )
    },
  ];
  //#endregion

  const handleRemove = async(email: string)=> {
    Modal.confirm({
      content: '确定删除此邮箱？',
      okText: '确定',
      cancelText: '取消',
      onOk: async ()=> {
        const { code, message} = await delAdmEmail({ email })
        if (code === 0) {
          messager.success('删除成功')
          await fetchPaginate()
        } else {
          messager.error(message)
        }
      }
    })
  }

  const fetchPaginate = async ()=> {
    setLoading(true)
    const { data } = await getAdmEmail()
    setLoading(false)
    setDataSource(data)
  }

  useEffect(()=> {
    fetchPaginate()
  }, [])

  return (
    <div className={modStyl.wrapper}>
      <div className={modStyl.condition}>
        <Row gutter={16}>
          <Col span={21}></Col>
          <Col span={3} style={{display: 'flex', justifyContent: 'flex-end'}}>
            <Button onClick={()=> setVisible(true)} type="primary">添加邮箱</Button>
          </Col>
        </Row>
      </div>
      <Table
        loading={loading}
        size="middle"
        rowKey='id'
        columns={columns}
        dataSource={dataSource}
        pagination={false}
        locale={{emptyText: <Empty description="暂无数据"/>}}
      />

      {
        visible && (
          <CreateModal onClose={()=> {
              fetchPaginate()
              setVisible(false)
          }}/>
        )
      }
        
    </div>
  )
}

export default EmailManagement